export const MANUAL_IRRIGATION_FLAGS = ['MANUAL_IRRIGATION', 'IRRIGAIT']
export const EMERGENCY_SHOT_FLAGS = ['EMERGENCY_SHOT', 'IRRIGAIT']
export const FACILITY_IRRIGATION_FLAGS = ['FACILITY_IRRIGATION', 'IRRIGAIT']
export const DYNAMIC_IRRIGATION_FLAGS = ['DYNAMIC_IRRIGATION', 'AUTOMAIT']
